import { CheckCircle } from "lucide-react";
import { homeCommercialRequirements } from "../homeShellData";
import HomeTextAction from "./homeTextAction";
import { PointMarker } from "./homeFreshness";

const HomeCommercialRequirements = () => (
    <section
        aria-labelledby="home-commercial-requirements-heading"
        className="border border-light-subtle k-bg-brand-standard rounded-4 px-4 py-3 mb-4 mb-lg-5 mx-auto"
        style={{ maxWidth: "45rem" }}
    >
        <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-2">
            <h2
                id="home-commercial-requirements-heading"
                className="fs-8 fw-semibold text-uppercase letter-spacing-wide k-text-primary mb-0 d-inline-flex align-items-center gap-2"
            >
                <CheckCircle size={16} strokeWidth={2} aria-hidden="true" />
                Your commercial requirements
            </h2>
            <HomeTextAction>Manage Commercial Requirements</HomeTextAction>
        </div>
        <ul className="d-flex flex-column mb-0 ps-0 fs-8 gap-2">
            {homeCommercialRequirements.map(requirement => (
                <li key={requirement} className="d-flex list-unstyled align-items-center">
                    <PointMarker className="me-2" />
                    {requirement}
                </li>
            ))}
        </ul>
    </section>
);

export default HomeCommercialRequirements;
